import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';
import ApiDataBase from 'server';
import AdditionalInfoSection from './additionalInfoSection';
import CompanyQualificationSection from './companyQualificationSection';
import LocationSection from './locationSection';
import PrerequisitesSection from './prerequisitesSection';
import ReferenceSection from './referenceSection';
import ResponsibleSection from './responsibleSection';
import SalarySection from './salarySection';

const slideOverAddMissionGeneral = () => {
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const [company, setCompany] = useState(() => ({
    name: dataCreateMission.company || null,
  }));
  const [companyList, setCompanyList] = useState([]);
  const [errorsCompany, setErrorsCompany] = useState({});
  const [qualification, setQualification] = useState({
    name: dataCreateMission.qualification || '',
  });
  const [qualificationList, setQualificationList] = useState([]);
  const [errorsQualification, setErrorsQualification] = useState({});

  const [materials, setMaterials] = useState([]);
  const [permits, setPermits] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [address, setAddress] = useState(dataCreateMission.location || '');

  const [personInCharge, setPersonInCharge] = useState(
    dataCreateMission.contact_name || ''
  );
  const [errorsPersonInCharge, setErrorsPersonInCharge] = useState();
  const [personInChargeFunction, setPersonInChargeFunction] = useState(
    dataCreateMission.contact_poste || 'Responsable'
  );
  const [errorsPersonInChargeFunction, setErrorsPersonInChargeFunction] =
    useState();

  const [other, setOther] = useState(dataCreateMission.other || '');
  const [errorsOther, setErrorsOther] = useState('');
  const [otherInterim, setOtherInterim] = useState(
    dataCreateMission.other_interim || ''
  );
  const [errorsOtherInterim, setErrorsOtherInterim] = useState('');

  const [smic, setSmic] = useState('');
  const [salary, setSalary] = useState(dataCreateMission.salary || '');

  const [lastMissionSuggestions, setLastMissionSuggestions] = useState([]);
  const [lastContactSuggestions, setLastContactSuggestions] = useState([]);
  const [listEmployees, setListEmployees] = useState([]);

  const [sectors, setSectors] = useState([]);
  const [activeQualifications, setActiveQualifications] = useState([]);
  const [selectedSector, setSelectedSector] = useState(
    dataCreateMission.sector || ''
  );

  // handlers existants...
  const handleChangeCompany = (updatedCompanyList) => {
    const checkedItem = updatedCompanyList.find((item) => item.checked);
    setCompany({ name: checkedItem?.value || '' });
    setErrorsCompany({
      name: checkedItem?.value ? '' : 'Veuillez sélectionner une entreprise',
    });
  };

  const handleChangeQualification = (updatedQualificationList) => {
    const checkedItem = updatedQualificationList.find((item) => item.checked);
    setQualification({ name: checkedItem?.value || '' });
    setErrorsQualification({
      name: checkedItem?.value ? '' : 'Veuillez sélectionner une qualification',
    });
  };

  useEffect(() => {
    if (!token) return;
    ApiDataBase.getCompaniesForMissionCreation(
      { token },
      (data) => {
        if (data.companies.length > 0) {
          const mapped = data.companies.map((c) => ({
            value: c._id,
            label: c.name_commercial + ' - ' + c.reason_social,
            location: c.location,
            checked: c._id === dataCreateMission.company,
          }));
          setCompanyList(mapped);
          if (dataCreateMission.company) {
            setCompany({ name: dataCreateMission.company });
          }
        }
      },
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
  }, [token, dataCreateMission.company]);

  useEffect(() => {
    if (!token) return;
    ApiDataBase.getTypesQualifications(
      { token },
      (data) => {
        setSectors(data);
      },
      (err) => console.error(err)
    );
  }, [token]);

  useEffect(() => {
    if (!token) return;
    ApiDataBase.getQualificationsActive(
      { token },
      (data) => {
        setActiveQualifications(data);
      },
      (err) => console.error(err)
    );
  }, [token]);

  useEffect(() => {
    if (selectedSector) {
      const filtered = activeQualifications.filter(
        (q) => q.type === selectedSector
      );
      setQualificationList(
        filtered.map((q) => ({
          value: q._id,
          label: q.name,
          type: q.type, // 👈 on garde le type
          checked: q._id === dataCreateMission.qualification,
        }))
      );
    } else {
      // aucun secteur => on affiche toutes les qualifications
      setQualificationList(
        activeQualifications.map((q) => ({
          value: q._id,
          label: q.name,
          type: q.type, // 👈 et ici aussi
          checked: q._id === dataCreateMission.qualification,
        }))
      );
    }
  }, [selectedSector, activeQualifications, dataCreateMission.qualification]);

  const handleSectorToggle = (sec) => {
    const wasSelected = selectedSector === sec;
    const newSector = wasSelected ? '' : sec;
    setSelectedSector(newSector);
    setDataCreateMission((prev) => ({
      ...prev,
      sector: newSector,
      qualification: wasSelected ? '' : prev.qualification,
    }));
    if (wasSelected) {
      setQualification({ name: '' });
    }
  };

  const handleSectorSelect = (sec) => {
    setSelectedSector(sec);
    setDataCreateMission((prev) => ({
      ...prev,
      sector: sec,
    }));
  };

  useEffect(() => {
    const idCompany = dataCreateMission.company;
    if (!token || !idCompany) return;

    ApiDataBase.getCompanyQualificationSuggestionsFromRecentMissions(
      { token, idCompany },
      (data) => {
        setLastMissionSuggestions(data);
      },
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
  }, [token, dataCreateMission.company]);

  useEffect(() => {
    const idCompany = dataCreateMission.company;
    if (!token || !idCompany) return;
    ApiDataBase.getRecentContactNamesForMissionCreation(
      { token, idCompany },
      (data) => setLastContactSuggestions(data),
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
    ApiDataBase.getListEmployeesForMissionCreation(
      { token, idCompany },
      (data) => setListEmployees(data),
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
  }, [token, dataCreateMission.company]);

  useEffect(() => {
    if (!token) return;
    ApiDataBase.getListLanguages(
      (data) => {
        setLanguages(
          data.map((lang) => ({
            name: lang.name,
            checked: dataCreateMission.languages.includes(lang.name),
          }))
        );
      },
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
  }, [token]);

  useEffect(() => {
    if (!token) return;
    ApiDataBase.getListTools(
      (data) => {
        setMaterials(
          data.map((tool) => ({
            name: tool.name,
            checked: dataCreateMission.tools.includes(tool.name),
          }))
        );
      },
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
  }, [token]);

  useEffect(() => {
    if (!token) return;
    ApiDataBase.getAllLicence(
      (data) => {
        setPermits(
          data.map((licence) => ({
            name: licence.name,
            checked: dataCreateMission.licences.includes(licence.name),
          }))
        );
      },
      (err) => {
        if (err.name !== 'CanceledError') console.error(err);
      }
    );
  }, [token]);

  return (
    <div className="flex flex-col gap-8">
      <CompanyQualificationSection
        companyList={companyList}
        company={company}
        errorsCompany={errorsCompany}
        handleChangeCompany={handleChangeCompany}
        qualificationList={qualificationList}
        qualification={qualification}
        errorsQualification={errorsQualification}
        handleChangeQualification={handleChangeQualification}
        setDataCreateMission={setDataCreateMission}
        sectors={sectors}
        selectedSector={selectedSector}
        onSectorToggle={handleSectorToggle}
        onForceSectorSelect={handleSectorSelect}
        lastMissionSuggestions={lastMissionSuggestions}
        activeQualifications={activeQualifications}
      />
      <PrerequisitesSection
        materials={materials}
        updateMaterials={(u) => {
          setMaterials(u);
        }}
        permits={permits}
        updatePermits={(u) => {
          setPermits(u);
        }}
        languages={languages}
        updateLanguages={(u) => {
          setLanguages(u);
        }}
        setDataCreateMission={setDataCreateMission}
      />
      <ReferenceSection
        reference={dataCreateMission.reference}
        setDataCreateMission={setDataCreateMission}
      />
      <LocationSection
        address={address}
        setAddress={setAddress}
        dataCreateMission={dataCreateMission}
        setDataCreateMission={setDataCreateMission}
      />
      <SalarySection
        smic={smic}
        salary={salary}
        setSmic={setSmic}
        setSalary={setSalary}
        setDataCreateMission={setDataCreateMission}
      />
      <ResponsibleSection
        personInCharge={personInCharge}
        setPersonInCharge={setPersonInCharge}
        personInChargeFunction={personInChargeFunction}
        setPersonInChargeFunction={setPersonInChargeFunction}
        errorsPersonInCharge={errorsPersonInCharge}
        errorsPersonInChargeFunction={errorsPersonInChargeFunction}
        setDataCreateMission={setDataCreateMission}
        lastContactSuggestions={lastContactSuggestions}
        listEmployees={listEmployees}
      />
      <AdditionalInfoSection
        other={other}
        setOther={setOther}
        errorsOther={errorsOther}
        otherInterim={otherInterim}
        setOtherInterim={setOtherInterim}
        errorsOtherInterim={errorsOtherInterim}
        setDataCreateMission={setDataCreateMission}
      />
    </div>
  );
};

export default slideOverAddMissionGeneral;
